import PropTypes from 'prop-types';

import { DATA_GRID_FILTER_PANEL_TYPE } from 'constants/components';
import { ALL_OPTIONS_VALUE } from 'constants/common';

import { MultiSelectFilterPanel } from './MultiSelectFilterPanel';
import { SingleSelectFilterPanel } from './SingleSelectFilterPanel';

export const FilterPanel = ({
  filterType = DATA_GRID_FILTER_PANEL_TYPE.SINGLE_SELECT,
  filterProps: { filterValue, ...rest } = {
    onChangeFilterModel: () => {},
    filterValue: null,
    valueOptions: [],
  },
}) => {
  switch (filterType) {
    case DATA_GRID_FILTER_PANEL_TYPE.SINGLE_SELECT:
      return <SingleSelectFilterPanel {...rest} filterValue={filterValue || ALL_OPTIONS_VALUE} />;
    case DATA_GRID_FILTER_PANEL_TYPE.MULTIPLE_SELECT:
      return <MultiSelectFilterPanel {...rest} filterValue={filterValue || []} />;
    default:
      return null;
  }
};

FilterPanel.propTypes = {
  filterType: PropTypes.oneOf(Object.values(DATA_GRID_FILTER_PANEL_TYPE)),
  filterProps: PropTypes.shape({
    onChangeFilterModel: PropTypes.func.isRequired,
    filterValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    valueOptions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
};
